import { useEffect, useState } from 'react';
import { templateService } from '../services';

export default function useTemplates() {
  const [templates, setTemplates] = useState([]);

  useEffect(() => {
    const fetchTemplates = async () => {
      try {
        const data = await templateService.list();

        if (data.success && data.templates) {
          setTemplates(data.templates);
        }
      } catch (error) {
        console.error('Erro ao buscar templates:', error);
      }
    };

    fetchTemplates();
  }, []);

  return {
    templates,
    setTemplates
  };
}
